export default "__VITE_ASSET__iNwWarMu__ 480w, __VITE_ASSET__CikANO$k__ 720w, __VITE_ASSET__C9RVf5sp__ 960w, __VITE_ASSET__B0KC8BbK__ 1280w";